// extracted by mini-css-extract-plugin
module.exports = {"newsLetter2":"Newsletter2_newsLetter2__S1IQd","form":"Newsletter2_form____nD9","title":"Newsletter2_title__CRAYf","spinner":"Newsletter2_spinner__LNCxl"};